module.exports = __webpack_public_path__ + "assets/img/life-4.6750588c.jpg";